<template>
  <li :class="['mobile-search', { active }]" @click="$f.showNav('search')">
    <span class="link">
      <f-sprite-icon :icon-link="$options.icons.IconSearch.id" />
      Поиск
    </span>
    <div class="tree-menu depth2">
      <vue-client-only>
        <mobile-menu-header
          title="Поиск"
          show-back
          @back.stop="$f.showNav()"
        />
      </vue-client-only>
      <div class="mobile-search-container">
        <search-form v-if="active" />
      </div>
    </div>
  </li>
</template>

<script>
import IconSearch from '../../assets/icons/search.svg';
import VueClientOnly from 'vue-client-only';

import MobileMenuHeader from './mobile-menu-header.vue';
import SearchForm from '../search/search-form.vue';


export default {
  name: 'mobile-search',

  components: {
    MobileMenuHeader,
    SearchForm,
    VueClientOnly,
  },

  icons: {
    IconSearch,
  },

  data: () => ({
    query: ''
  }),

  computed: {
    active() {
      return this.$f.navSection === 'search';
    }
  }
}
</script>

<style lang="scss">
.mobile-search {
  &-container {
    padding: $containerGapMobile;
  }
}
</style>
